import { useQuery } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'

import type { BusinessNote } from '../schemas/note-schema'

const getNotes = async (referralShareId?: number, leadInquiryId?: number): Promise<BusinessNote[] | undefined> => {
  return getRequest<BusinessNote[]>(
    `/business/notes?${
      referralShareId ? 'referral_share_id=' + referralShareId : leadInquiryId ? 'lead_inquiry_id=' + leadInquiryId : ''
    }`,
  )
}

/**
 * Hook to fetch notes for a referral share or lead inquiry
 */
export const useNotes = (referralShareId?: number, leadInquiryId?: number) => {
  return useQuery({
    queryKey: queries.notes.list({ referralShareId, leadInquiryId }).queryKey,
    queryFn: () => getNotes(referralShareId, leadInquiryId),
    enabled: Boolean(referralShareId || leadInquiryId),
  })
}
